import { render, staticRenderFns } from "./popup-period.vue?vue&type=template&id=18711f4c&"
import script from "./popup-period.vue?vue&type=script&lang=js&"
export * from "./popup-period.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports